import React from 'react';
import { func, number, string } from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { grey_1000 } from '@fiverr-private/sass/helpers';
import { l_chevron_left } from '@fiverr-private/icons';

import './index.scss';

const Arrow = ({ icon, direction, className, iconSize, onScroll }) => (
    <button className={classNames('arrow-btn', 'box-shadow-z1', direction, className)}
        onClick={onScroll} aria-label={direction}>
        <Icon color={grey_1000} size={iconSize} className="chevron-icon">{icon}</Icon>
    </button>
);

Arrow.defaultProps = {
    icon: l_chevron_left,
    direction: '',
    className: '',
    onScroll: Function.prototype
};

Arrow.propTypes = {
    icon: func,
    direction: string,
    className: string,
    iconSize: number,
    onScroll: func
};

export default Arrow;
